import { useLocalePreference } from '~/composables/useLocalePreference'

export function useLocaleRestore(): () => Promise<void> {
  const { $i18n } = useNuxtApp()
  const preference = useLocalePreference()

  return async () => {
    const restored = preference.restore()
    if (restored === undefined) return
    if (restored !== $i18n.locale.value) await $i18n.setLocale(restored)
    preference.set(restored)
  }
}
